import React, { createContext, useState, useEffect } from 'react'
import Header from './Header'
import HeaderVert from './HeaderVert'
import Footer from './Footer'
import Target from './Target'
import ImagePanel from './ImagePane'
import './layout.css'
import styled from 'styled-components'
import media from 'styles/media'

export const ScreenContext = createContext(null)
export const TabletLandscapeContext = createContext(null)

export const Layout: React.FC<{ isDarkMode?: boolean }> = ({
  children,
  isDarkMode,
}) => {
  const [desktop, setDesktop] = useState(null)
  const [tabletLandscape, setTabletLandscape] = useState(null)

  const [menuOpen, setMenuOpen] = useState(false)
  const [imageState, setImageState] = useState(0)

  useEffect(() => {
    setDesktop(window.innerWidth < 1024 ? false : true)
    setTabletLandscape(window.innerWidth <= 1200 ? true : false)

    window.addEventListener('resize', () => {
      setDesktop(window.innerWidth < 1024 ? false : true)
      setTabletLandscape(window.innerWidth <= 1200 ? true : false)
    })

    return () => {
      window.removeEventListener('resize', () => {})
    }
  }, [])

  return (
    <ScreenContext.Provider value={desktop}>
      <TabletLandscapeContext.Provider value={tabletLandscape}>
        <Header
          menuOpen={menuOpen}
          setMenuOpen={setMenuOpen}
          isDarkMode={isDarkMode}
        />
        <ImagePanel imageState={imageState} />
        <HeaderVert
          setImageState={setImageState}
          menuOpen={menuOpen}
          isDarkMode={isDarkMode}
        />
        <Target menuOpen={menuOpen} isDarkMode={isDarkMode} />
        <Main>{children}</Main>
        <Footer isDarkMode={isDarkMode} />
      </TabletLandscapeContext.Provider>
    </ScreenContext.Provider>
  )
}

const Main = styled.main`
  width: 100%;
  overflow: hidden;
  ${media.tabletLandscape} {
    padding-top: 48px;
  }
`

export default Layout
